import React, { useState } from "react";
import { resourceOwner } from "../../utils/accessManagement";

export default function ResourceOwnershipForm({ catalog, administrators, busy, onSave }) {
    const [kind, setKind] = useState("servers");
    const [owner, setOwner] = useState("");
    const [resource, setResource] = useState("");
    const [error, setError] = useState("");
    const rows = catalog[kind].filter((row) => !resourceOwner(row) || resourceOwner(row) === Number(owner));
    const submit = async (event) => {
        event.preventDefault();
        setError("");
        try {
            await onSave(kind, Number(resource), Number(owner));
            setResource("");
        } catch (failure) { setError(failure.message); }
    };
    return <section className="access-panel" aria-labelledby="access-ownership-heading">
        <h2 id="access-ownership-heading">Assign resources to an administrator</h2>
        <p>Choose the administrator's server pool, tag groups and Designer pages before assigning resource access to their users. Existing resource contents are preserved.</p>
        <form onSubmit={submit}><fieldset disabled={busy}>
            <div className="access-grid">
                <label>Resource type<select value={kind} onChange={(event) => { setKind(event.target.value); setResource(""); }}>
                    <option value="servers">Server</option><option value="groups">Tag group</option><option value="pages">Designer page</option>
                </select></label>
                <label>Administrator<select required value={owner} onChange={(event) => { setOwner(event.target.value); setResource(""); }}>
                    <option value="">Select administrator</option>{administrators.map((row) => <option key={row.id} value={row.id}>{row.email}</option>)}
                </select></label>
                <label>Resource<select required disabled={!owner} value={resource} onChange={(event) => setResource(event.target.value)}>
                    <option value="">Select resource</option>{rows.map((row) => <option key={row.id} value={row.id}>{row.name || row.title} (#{row.id})</option>)}
                </select></label>
            </div>
            <p className="access-hint">Resources already owned by another administrator cannot be transferred here. Assign parent groups before their children.</p>
            {error && <p className="access-error" role="alert">{error}</p>}
            <button type="submit">{busy ? "Saving…" : "Assign resource"}</button>
        </fieldset></form>
    </section>;
}
